/* OKO 2.0 — product tiles
   Size pills and quick add, wired once for the whole document so a tile works
   in the products grid, in search results, or anywhere else it is rendered.
   Listeners are delegated, so tiles injected later (filtering, pagination)
   need no re-binding. */
(function(){
  var I18N  = window.OKO2_I18N || {};
  var ADDED = I18N.added || 'Added';
  var ERR   = I18N.add_error || 'Could not add — please try again.';
  var CART  = I18N.cart || 'Cart';

  function setBadge(count){
    var btn = document.querySelector('.oko2-hdr .icon-btn[aria-label="' + CART + '"]');
    if(!btn) return;
    var b = btn.querySelector('.badge');
    if(!b){
      if(count < 1) return;
      b = document.createElement('span'); b.className = 'badge'; btn.appendChild(b);
    }
    b.textContent = count;
    b.hidden = count < 1;
  }

  document.addEventListener('click', function(e){
    if(!e.target.closest) return;

    /* Choosing a size: repoint the price and arm the button with that variant. */
    var size = e.target.closest('.psize');
    if(size){
      e.preventDefault();
      var card = size.closest('.pcard');
      if(!card) return;
      [].slice.call(card.querySelectorAll('.psize')).forEach(function(b){
        b.classList.remove('is-on'); b.setAttribute('aria-pressed','false');
      });
      size.classList.add('is-on'); size.setAttribute('aria-pressed','true');
      /* .pcard-price, not [data-price] — the size buttons carry that attribute
         too and they come first in the DOM. */
      var price = card.querySelector('.pcard-price');
      if(price && size.getAttribute('data-price')) price.textContent = size.getAttribute('data-price');
      var addBtn = card.querySelector('.pcard-add');
      if(addBtn) addBtn.setAttribute('data-vid', size.getAttribute('data-vid'));
      return;
    }

    var add = e.target.closest('.pcard-add');
    /* The sold-out state borrows the same class for its styling but is a span
       with no variant on it — it must not fall into the add path. */
    if(!add || add.tagName !== 'BUTTON' || !add.getAttribute('data-vid')) return;
    e.preventDefault();
    if(add.getAttribute('data-busy')) return;
    add.setAttribute('data-busy','1');

    var msg = add.closest('.pcard').querySelector('.pcard-msg');
    if(msg) msg.hidden = true;
    add.classList.add('is-busy');

    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(add.getAttribute('data-vid'), 10), quantity: 1}]})
    })
      .then(function(r){ if(!r.ok) throw new Error('add'); return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        setBadge(cart.item_count);
        add.classList.remove('is-busy');
        add.classList.add('is-done');
        if(msg){ msg.textContent = ADDED; msg.hidden = false; }
        setTimeout(function(){
          add.classList.remove('is-done');
          add.removeAttribute('data-busy');
          if(msg) msg.hidden = true;
        }, 2200);
      })
      .catch(function(){
        add.classList.remove('is-busy');
        add.removeAttribute('data-busy');
        if(msg){
          msg.textContent = ERR; msg.hidden = false;
          setTimeout(function(){ msg.hidden = true; }, 5000);
        }
      });
  });
})();
